import { render, staticRenderFns } from "./PlacesPartsTable.vue?vue&type=template&id=f8425f46&"
import script from "./PlacesPartsTable.vue?vue&type=script&lang=js&"
export * from "./PlacesPartsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports